import type { Entity as AcademyEntity } from '@mathflat/domain/@entities/Academy/dto'

export type UserPropertiesSchema = {
  CRM학원분류값: AcademyEntity.Academy['customerType']
  D코드: AcademyEntity.Academy['academyId']
  학원명: AcademyEntity.Academy['name']
  이메일: AcademyEntity.Academy['email']
  등록학생수: AcademyEntity.Academy['studentCount']
  기관명: AcademyEntity.Academy['academyAdditionalData']['organizationName']
}

export const convertAcademyToUserProperties = ({
  academy,
}: {
  academy: AcademyEntity.Academy
}): Partial<UserPropertiesSchema> => {
  return {
    D코드: academy.academyId,
    학원명: academy.name,
    CRM학원분류값: academy.customerType,
    이메일: academy.email,
    등록학생수: academy.studentCount,
    기관명: academy.academyAdditionalData.organizationName,
  }
}
